var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadheaderCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.6665H5C4.55798 1.6665 4.13405 1.8421 3.82149 2.15466C3.50893 2.46722 3.33334 2.89114 3.33334 3.33317V16.6665C3.33334 17.1085 3.50893 17.5325 3.82149 17.845C4.13405 18.1576 4.55798 18.3332 5 18.3332H15C15.442 18.3332 15.866 18.1576 16.1785 17.845C16.4911 17.5325 16.6667 17.1085 16.6667 16.6665V6.6665L11.6667 1.6665ZM11.25 13.3332V15.8332H8.75V13.3332H6.66667L10 9.99984L13.3333 13.3332H11.25ZM10.8333 7.49984V2.9165L15.4167 7.49984H10.8333Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadheaderCourse);
export default __webpack_public_path__ + "static/media/uploadheaderCourse.ef3d64402902df317fe6a6f3d381ac4b.svg";
export { ForwardRef as ReactComponent };